var EIndividualReviewFeedbackOptions = /* @__PURE__ */ ((EIndividualReviewFeedbackOptions2) => {
  EIndividualReviewFeedbackOptions2["HELPFUL"] = "HELPFUL";
  EIndividualReviewFeedbackOptions2["UNHELPFUL"] = "UNHELPFUL";
  EIndividualReviewFeedbackOptions2["REPORT"] = "REPORT";
  EIndividualReviewFeedbackOptions2["NONE"] = "NONE";
  return EIndividualReviewFeedbackOptions2;
})(EIndividualReviewFeedbackOptions || {});
var ESortCategory = /* @__PURE__ */ ((ESortCategory2) => {
  ESortCategory2["RELEVANCY"] = "RELEVANCY";
  ESortCategory2["MOST_HELPFUL"] = "MOST_HELPFUL";
  ESortCategory2["MOST_RECENT"] = "MOST_RECENT";
  ESortCategory2["HIGHEST_RATING"] = "HIGHEST_RATING";
  ESortCategory2["LOWEST_RATING"] = "LOWEST_RATING";
  return ESortCategory2;
})(ESortCategory || {});
var EProductReviewsErrorState = /* @__PURE__ */ ((EProductReviewsErrorState2) => {
  EProductReviewsErrorState2[EProductReviewsErrorState2["NONE"] = 0] = "NONE";
  EProductReviewsErrorState2[EProductReviewsErrorState2["SUMMARY_ERROR"] = 1] = "SUMMARY_ERROR";
  EProductReviewsErrorState2[EProductReviewsErrorState2["REVIEW_LOADING_ERROR"] = 2] = "REVIEW_LOADING_ERROR";
  return EProductReviewsErrorState2;
})(EProductReviewsErrorState || {});
export {
  EIndividualReviewFeedbackOptions,
  EProductReviewsErrorState,
  ESortCategory
};
//# sourceMappingURL=ProductReviewsModel.mjs.map
